import styled from 'styled-components';

export const StyledPlayerLevel = styled.div`
  max-width: 400px;
  position: relative;
  display: flex;
  font-family: 'Lemon Milk';

  @media (max-width: $tablet) {
    max-width: 606px;
  }

  .image {
    max-width: 100%;
  }

  .top-text-container {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 30%;
    left: 50%;
    transform: translateX(-50%);
    top: 7%;
    height: 56%;

    .top-text {
      text-align: center;
      width: 100%;
      color: white;
      text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
      font-weight: 700;
      margin: auto 0;
      font-size: 26px;
    }
  }

  .bottom-text-container {
    position: absolute;
    display: flex;
    justify-content: center;
    max-width: 24%;
    left: 50%;
    transform: translateX(-50%);
    bottom: 12%;
    height: 23%;

    .bottom-text {
      width: 100%;
      text-align: center;
      color: white;
      font-size: 9px;
      font-weight: 400;
      margin: auto 0;
    }
  }
`;
